import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isDisabled", "id", "value", "menuPlacement", "variant", "onChange", "neutralOption"];
import "core-js/modules/es.array.map.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getLanguageList } from 'i18n/options';
import useUniqueId from 'hooks/useUniqueId';
import { getTypedSelectComponents, OptionsDivider } from 'components/Select';
import FormField from 'components/FormField';
var _getTypedSelectCompon = getTypedSelectComponents(),
  Select = _getTypedSelectCompon.Select,
  Option = _getTypedSelectCompon.Option;
var LanguageField = function LanguageField(_ref) {
  var isDisabled = _ref.isDisabled,
    id = _ref.id,
    value = _ref.value,
    _ref$menuPlacement = _ref.menuPlacement,
    menuPlacement = _ref$menuPlacement === void 0 ? 'top' : _ref$menuPlacement,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'transparent' : _ref$variant,
    onChange = _ref.onChange,
    _ref$neutralOption = _ref.neutralOption,
    neutralOption = _ref$neutralOption === void 0 ? 'select' : _ref$neutralOption,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId(id);
  var languageList = getLanguageList();
  function changeLanguage(newLocale) {
    onChange(newLocale === 'auto' ? null : newLocale);
  }
  return /*#__PURE__*/React.createElement(FormField, _extends({
    as: "span",
    label: t('form_language'),
    labelId: uniqueId
  }, otherProps), /*#__PURE__*/React.createElement(Select, {
    icon: "globe",
    labelledById: uniqueId,
    size: "medium",
    variant: variant,
    menuPlacement: menuPlacement,
    value: value || 'auto',
    onChange: changeLanguage,
    ml: variant === 'transparent' ? '-xxs' : 0,
    isDisabled: isDisabled
  }, neutralOption === 'auto' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Option, {
    value: "auto"
  }, t('language_auto')), /*#__PURE__*/React.createElement(OptionsDivider, null)), neutralOption === 'select' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Option, {
    value: "auto"
  }, t('actions_select_language')), /*#__PURE__*/React.createElement(OptionsDivider, null)), languageList.map(function (value) {
    return /*#__PURE__*/React.createElement(Option, {
      key: value.value,
      value: value.value
    }, value.title);
  })));
};
export default LanguageField;